// SUPER SIMPLE EMAIL SERVICE
// All templates are here - just edit if you want to change them

import { supabase } from '../supabase';
import { checkRateLimit } from '../utils/rateLimiter';

// Reusable email header (same design for all emails)
const getEmailHeader = () => `
  <tr>
    <td style="background-color: #000000; padding: 20px; position: relative;">
      <table role="presentation" style="width: 100%; border-collapse: collapse;">
        <tr>
          <td style="vertical-align: middle;display: flex;
            align-items: center; justify-content: center;
            gap: 10px;">
           <img src="https://doctorsjobs.io/DoctorsJobs_favicon.png" alt="Doctors' Jobs" style="display: block; width: 30px; height: auto;">
            <span style="color: #ffffff; font-size: 24px; font-weight: bold;">Doctors' Jobs</span>
            <span style="background-color: #000000; color: #ffffff; font-size: 10px; padding: 2px 6px; margin-left: 8px; border-radius: 2px; font-weight: bold;">BETA</span>
          </td>
          <td style="text-align: right; vertical-align: middle;">
            <div style="display: inline-block; width: 20px; height: 20px;">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="4" height="4" fill="#ffffff"/>
                <rect x="8" y="2" width="4" height="4" fill="#ffffff"/>
                <rect x="14" y="2" width="4" height="4" fill="#ffffff"/>
                <rect x="2" y="8" width="4" height="4" fill="#ffffff"/>
                <rect x="8" y="8" width="4" height="4" fill="#ffffff"/>
                <rect x="14" y="8" width="4" height="4" fill="#ffffff"/>
                <rect x="2" y="14" width="4" height="4" fill="#ffffff"/>
                <rect x="8" y="14" width="4" height="4" fill="#ffffff"/>
                <rect x="14" y="14" width="4" height="4" fill="#ffffff"/>
              </svg>
            </div>
          </td>
        </tr>
      </table>
    </td>
  </tr>
`;

// Reusable email wrapper
const getEmailWrapper = (content) => `
  <!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
  </head>
  <body style="margin: 0; padding: 0; background-color: #f5f5f5; font-family: Arial, sans-serif;">
    <table role="presentation" style="width: 100%; border-collapse: collapse; background-color: #f5f5f5;">
      <tr>
        <td style="padding: 40px 20px;">
          <table role="presentation" style="width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; border-collapse: collapse;">
            ${getEmailHeader()}
            <tr>
              <td style="padding: 40px 30px;">
                ${content}
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
  </html>
`;

// Email templates
const templates = {
  // Email sent to candidate when they apply
  candidateConfirmation: (name, jobTitle, companyName, date) => {
    const firstName = name.split(' ')[0] || name;
    return {
      subject: `Thank you for applying 👋`,
      html: `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
        </head>
        <body style="margin: 0; padding: 0; background-color: #f5f5f5; font-family: Arial, sans-serif;">
          <table role="presentation" style="width: 100%; border-collapse: collapse; background-color: #f5f5f5;">
            <tr>
              <td style="padding: 40px 20px;">
                <table role="presentation" style="width: 100%; max-width: 600px; margin: 0 auto; background-color: #ffffff; border-collapse: collapse;">
                  <!-- Header Banner -->
                  <tr>
                    <td style="background-color: #000000; padding: 20px; position: relative;">
                      <table role="presentation" style="width: 100%; border-collapse: collapse;">
                        <tr>
                          <td style="vertical-align: middle;">
                            <span style="color: #ffffff; font-size: 24px; font-weight: bold;">Doctors' Jobs</span>
                            <span style="background-color: #000000; color: #ffffff; font-size: 10px; padding: 2px 6px; margin-left: 8px; border-radius: 2px; font-weight: bold;">BETA</span>
                          </td>
                          <td style="text-align: right; vertical-align: middle;">
                            <div style="display: inline-block; width: 20px; height: 20px;">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="2" width="4" height="4" fill="#ffffff"/>
                                <rect x="8" y="2" width="4" height="4" fill="#ffffff"/>
                                <rect x="14" y="2" width="4" height="4" fill="#ffffff"/>
                                <rect x="2" y="8" width="4" height="4" fill="#ffffff"/>
                                <rect x="8" y="8" width="4" height="4" fill="#ffffff"/>
                                <rect x="14" y="8" width="4" height="4" fill="#ffffff"/>
                                <rect x="2" y="14" width="4" height="4" fill="#ffffff"/>
                                <rect x="8" y="14" width="4" height="4" fill="#ffffff"/>
                                <rect x="14" y="14" width="4" height="4" fill="#ffffff"/>
                              </svg>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <!-- Content -->
                  <tr>
                    <td style="padding: 40px 30px;">
                      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Hi ${firstName},</p>
                      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Thank you for applying for the <strong>${jobTitle}</strong> position at <strong>${companyName}</strong> through Doctors' Jobs.</p>
                      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">We've received your application and the hiring team will be reviewing it shortly. If your profile matches the role, you'll be contacted about the next steps.</p>
                      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">In the meantime, you can track your <strong><a href="https://doctorsjobs.io/job-applications-tracker" style="color: #000000; text-decoration: underline;">application</a></strong> or <strong><a href="https://doctorsjobs.io/" style="color: #000000; text-decoration: underline;">explore more opportunities</a></strong> that fit your skills.</p>
                      <p style="margin: 0 0 10px 0; font-size: 16px; line-height: 1.6; color: #333333;">Kind regards,</p>
                      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
        </html>
      `,
      text: `Hi ${firstName},\n\nThank you for applying for the ${jobTitle} position at ${companyName} through Doctors' Jobs.\n\nWe've received your application and the hiring team will be reviewing it shortly. If your profile matches the role, you'll be contacted about the next steps.\n\nIn the meantime, you can track your application or explore more opportunities that fit your skills.\n\nKind regards,\nThe Doctors' Jobs Team`
    };
  },

  // Email sent to employer when they get a new application
  employerNotification: (
    employerName,
    candidateName,
    candidateEmail,
    jobTitle,
    date,
    applicationLink
  ) => {
    const firstName = employerName?.split(' ')[0] || employerName || 'there';
    const formattedDate = date
      ? new Date(date).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })
      : '';

    // If applicationLink is an employer job detail page, redirect through login
    let finalApplicationLink = applicationLink || 'https://doctorsjobs.io/login';
    if (applicationLink && applicationLink.includes('/employer/job-detail/')) {
      // Extract the job detail path and create login redirect link
      const jobDetailPath = applicationLink.includes('https://dev.doctorsjobs.io')
        ? applicationLink.replace('https://dev.doctorsjobs.io', '')
        : applicationLink.replace('https://doctorsjobs.io', '');
      finalApplicationLink = `https://doctorsjobs.io/login?redirect=${encodeURIComponent(jobDetailPath)}`;
    }

    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Hi ${firstName},</p>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">You’ve received a new application for <strong>${jobTitle}</strong>.</p>
      <p style="margin: 0 0 15px 0; font-size: 16px; line-height: 1.6; color: #333333;">Here are the applicant’s details:</p>
      <p style="margin: 0 0 8px 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>Name:</strong> ${candidateName}</p>
      <p style="margin: 0 0 8px 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>Email:</strong> ${candidateEmail || 'Not provided'}</p>
      <p style="margin: 0 0 24px 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>Applied On:</strong> ${formattedDate}</p>
      <div style="text-align: center; margin: 32px 0 32px 0;">
        <a
          href="${applicationLink || 'https://doctorsjobs.io/'}"
          style="display: inline-block; background-color: #000000; color: #ffffff; padding: 14px 32px; text-decoration: none; border-radius: 4px; font-weight: bold; font-size: 16px;"
        >
          View Application
        </a>
      </div>
      <p style="margin: 0 0 24px 0; font-size: 16px; line-height: 1.6; color: #333333;">You can view the full application and CV by logging into your Doctors’ Jobs dashboard.</p>
      <p style="margin: 0 0 8px 0; font-size: 16px; line-height: 1.6; color: #333333;">Kind regards,</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors’ Jobs Team</strong></p>
    `;

    return {
      subject: `New Applicant Alert: ${jobTitle}`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nYou’ve received a new application for ${jobTitle}.\n\nHere are the applicant’s details:\n\nName: ${candidateName}\nEmail: ${
        candidateEmail || 'Not provided'
      }\nApplied On: ${formattedDate}\n\nView Application: ${
        applicationLink || 'https://doctorsjobs.io/'
      }\n\nYou can view the full application and CV by logging into your Doctors’ Jobs dashboard.\n\nKind regards,\nThe Doctors’ Jobs Team`
    };
  },

  // 1. Disqualification email
  disqualification: (name, jobTitle, companyName, reason) => {
    const firstName = name.split(' ')[0] || name;
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Hi ${firstName},</p>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Thank you for taking the time to apply for the <strong>${jobTitle}</strong> position at <strong>${companyName}</strong> through Doctors' Jobs.</p>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">After reviewing your application, we have decided to move forward with other candidates at this time. We truly appreciate your interest and encourage you to keep exploring new opportunities on <strong>Doctors' Jobs</strong> that match your skills and experience.</p>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">Wishing you all the best in your career ahead.</p>
      <p style="margin: 0 0 10px 0; font-size: 16px; line-height: 1.6; color: #333333;">Kind regards,</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `Update on your job application 👋`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nThank you for taking the time to apply for the ${jobTitle} position at ${companyName} through Doctors' Jobs.\n\nAfter reviewing your application, we have decided to move forward with other candidates at this time. We truly appreciate your interest and encourage you to keep exploring new opportunities on Doctors' Jobs that match your skills and experience.\n\nWishing you all the best in your career ahead.\n\nKind regards,\nThe Doctors' Jobs Team`
    };
  },

  // 2. Next step in interview process
  nextStep: (name, jobTitle, companyName, stage, jobLink, jobId) => {
    const firstName = name.split(' ')[0] || name;
    // Use job detail page if jobId provided, otherwise use application tracker
    // For job detail pages, redirect through login to ensure user is authenticated
    const buttonLink = jobId 
      ? `https://doctorsjobs.io/login?redirect=/job/${jobId}`
      : (jobLink || 'https://doctorsjobs.io/job-applications-tracker');
    const buttonText = jobId ? 'See Update' : 'Track your application';
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>Hi ${firstName},</strong></p>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Good news! Your application for the <strong>${jobTitle}</strong> role at <strong>${companyName}</strong> has been updated.</p>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">The hiring team will contact you soon to discuss the next steps, which may include an interview or further screening.</p>
      <div style="text-align: center; margin: 0 0 30px 0;">
        <a href="${buttonLink}" style="display: inline-block; background-color: #000000; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">${buttonText}</a>
      </div>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">Wishing you all the best in your career ahead.</p>
      <p style="margin: 0 0 10px 0; font-size: 16px; line-height: 1.6; color: #333333;">Kind regards,</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `Next steps: Congratulation on your job application`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nGood news! Your application for the ${jobTitle} role at ${companyName} has been updated. \n\nThe hiring team will contact you soon to discuss the next steps, which may include an interview or further screening.\n\n${buttonText}: ${buttonLink}\n\nWishing you all the best in your career ahead.\n\nKind regards,\nThe Doctors' Jobs Team`
    };
  },

  // 3. Delete account confirmation
  accountDeleted: (name) => {
    const firstName = name.split(' ')[0] || name;
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Hi ${firstName},</p>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">This email confirms that your Doctors' Jobs account has been successfully deleted. We're sorry to see you go, but we understand.</p>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">If this was a mistake or you change your mind, you're always welcome to sign up again and start fresh.</p>
      <div style="text-align: center; margin: 0 0 30px 0;">
        <a href="https://doctorsjobs.io/signup" style="display: inline-block; background-color: #2d3748; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">Create an account</a>
      </div>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Have questions or feedback? We'd love to hear from you, hit reply or email <a href="mailto:contact@fourminutemedicine.com" style="color: #0000ff; text-decoration: underline;">contact@fourminutemedicine.com</a>.</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `Doctors' jobs: Sorry to see you go`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nThis email confirms that your Doctors' Jobs account has been successfully deleted. We're sorry to see you go, but we understand.\n\nIf this was a mistake or you change your mind, you're always welcome to sign up again and start fresh.\n\nCreate an account: https://doctorsjobs.io/signup\n\nHave questions or feedback? We'd love to hear from you, hit reply or email contact@fourminutemedicine.com.\n\nThe Doctors' Jobs Team`
    };
  },

  // 4. Team invite
  teamInvite: (name, inviterName, companyName, role, inviteLink) => {
    const firstName = name.split(' ')[0] || name;
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>Hi ${firstName},</strong></p>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">You've been invited by <strong>${companyName}</strong> as <strong>${role}</strong> to join the hiring team on <strong>Doctors' Jobs</strong>. Click below to accept your invite and start hiring together:</p>
      <div style="text-align: center; margin: 0 0 30px 0;">
        <a href="${inviteLink}" style="display: inline-block; background-color: #2d3748; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">Accept Invite</a>
      </div>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">If you're new to Doctors' Jobs, you'll be prompted to set up your profile first.</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `You've been invited to join the hiring team 👋`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nYou've been invited by ${companyName} as ${role} to join the hiring team on Doctors' Jobs. Click below to accept your invite and start hiring together:\n\nAccept Invite: ${inviteLink}\n\nIf you're new to Doctors' Jobs, you'll be prompted to set up your profile first.\n\nThe Doctors' Jobs Team`
    };
  },

  // 5. Complete profile reminder
  completeProfile: (name) => {
    const firstName = name.split(' ')[0] || name;
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>Hi ${firstName},</strong></p>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">You're almost there! Your Doctors' Jobs account is set up, now complete your profile to start matching with employers:</p>
      <ul style="margin: 0 0 30px 0; padding-left: 20px; font-size: 16px; line-height: 1.8; color: #333333;">
        <li style="margin-bottom: 10px;">Get discovered by hiring managers faster</li>
        <li style="margin-bottom: 10px;">Receive personalised job recommendations</li>
        <li style="margin-bottom: 10px;">Apply to roles with one click</li>
      </ul>
      <div style="text-align: center; margin: 0 0 30px 0;">
        <a href="https://doctorsjobs.io/profile" style="display: inline-block; background-color: #2d3748; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">Complete My Profile</a>
      </div>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Take a minute to finish setting up your details and start getting matched to roles that fit your skills and experience.</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `Complete you Profile`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nYou're almost there! Your Doctors' Jobs account is set up, now complete your profile to start matching with employers:\n\n• Get discovered by hiring managers faster\n• Receive personalised job recommendations\n• Apply to roles with one click\n\nComplete My Profile: https://doctorsjobs.io/profile\n\nTake a minute to finish setting up your details and start getting matched to roles that fit your skills and experience.\n\nThe Doctors' Jobs Team`
    };
  },

  // 6. New job match notification
  jobMatch: (name, jobLink) => {
    const firstName = name.split(' ')[0] || name;
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Hi ${firstName},</p>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">Good news ! We've found new job opportunities that match your profile.</p>
      <div style="text-align: center; margin: 0 0 30px 0;">
        <a href="${jobLink || 'https://doctorsjobs.io/'}" style="display: inline-block; background-color: #2d3748; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px; line-height: 1.4;">View all Matching<br>Jobs</a>
      </div>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Your next career move could be just one click away.</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `New job matches on Doctors' Jobs 👋`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nGood news ! We've found new job opportunities that match your profile.\n\nView all Matching Jobs: ${jobLink || 'https://doctorsjobs.io/'}\n\nYour next career move could be just one click away.\n\nThe Doctors' Jobs Team`
    };
  },

  // 7. New message notification
  newMessage: (name, senderName, messageLink, messageCount = 1) => {
    const firstName = name.split(' ')[0] || name;
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>Hi ${firstName},</strong></p>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">You've received a new message from <strong>${senderName}</strong>.</p>
      <div style="text-align: center; margin: 0 0 30px 0;">
      </div>
      <div style="text-align: center; margin: 0 0 30px 0;">
        <a href="${messageLink || 'https://doctorsjobs.io/messages'}" style="display: inline-block; background-color: #000000; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">Read Message</a>
      </div>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `You've received ${messageCount} message${messageCount > 1 ? 's' : ''}`,
      html: getEmailWrapper(content),
      text: `Hi ${firstName},\n\nYou've received a new message from ${senderName}.\n\nRead Message: ${messageLink || 'https://doctorsjobs.io/messages'}\n\nThe Doctors' Jobs Team`
    };
  },

  // 8. Candidate verification request (admin notification)
  candidateVerificationRequest: (candidateName, reviewLink) => {
    const safeName = candidateName || 'a candidate';
    const link = reviewLink || 'https://doctorsjobs.io/admin/hpcsa-verification';
    const content = `
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Hi,</p>
      <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #333333;">A new candidate, <strong>${safeName}</strong>, is awaiting profile verification. Please review their details and approve their profile to make them visible to hiring teams.</p>
      <div style="text-align: center; margin: 0 0 30px 0;">
        <a href="${link}" style="display: inline-block; background-color: #000000; color: #ffffff; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px;">Review Candidate</a>
      </div>
      <p style="margin: 0 0 20px 0; font-size: 16px; line-height: 1.6; color: #333333;">Thanks for keeping our platform trustworthy and secure.</p>
      <p style="margin: 0; font-size: 16px; line-height: 1.6; color: #333333;"><strong>The Doctors' Jobs Team</strong></p>
    `;
    return {
      subject: `Candidate awaiting verification 👋`,
      html: getEmailWrapper(content),
      text: `Hi,\n\nA new candidate, ${safeName}, is awaiting profile verification. Please review their details and approve their profile to make them visible to hiring teams.\n\nReview Candidate: ${link}\n\nThanks for keeping our platform trustworthy and secure.\n\nThe Doctors' Jobs Team`
    };
  }
};

// Helper functions - just call these!
export async function sendCandidateConfirmation(candidateEmail, candidateName, jobTitle, companyName, applicationDate) {
  // Rate limit: Max 10 emails per hour per email address
  const rateLimitKey = `email_${candidateEmail}`;
  if (!checkRateLimit(rateLimitKey, 10, 3600000)) {
    return; // Silently fail to prevent spam
  }

  try {
    const email = templates.candidateConfirmation(candidateName, jobTitle, companyName, applicationDate);
    
    const { data, error } = await supabase.functions.invoke('send-application-email', {
      body: {
        to: candidateEmail,
        subject: email.subject,
        html: email.html,
        text: email.text
      }
    });

    if (error) {
      // Email error - silent fail
    }
  } catch (error) {
    // Failed to send email - silent fail
  }
}

export async function sendEmployerNotification(
  employerEmail,
  employerName,
  candidateName,
  candidateEmail,
  jobTitle,
  applicationDate,
  applicationLink
) {
  // Rate limit: Max 50 emails per hour per employer email
  const rateLimitKey = `email_${employerEmail}`;
  if (!checkRateLimit(rateLimitKey, 50, 3600000)) {
    return; // Silently fail to prevent spam
  }

  try {
    const email = templates.employerNotification(
      employerName,
      candidateName,
      candidateEmail,
      jobTitle,
      applicationDate,
      applicationLink
    );
    
    const { data, error } = await supabase.functions.invoke('send-application-email', {
      body: {
        to: employerEmail,
        subject: email.subject,
        html: email.html,
        text: email.text
      }
    });

    if (error) {
      // Email error - silent fail
    }
  } catch (error) {
    // Failed to send email - silent fail
  }
}

// Generic email sender function
async function sendEmailTemplate(emailType, recipientEmail, templateData) {
  // Rate limit: Max 20 emails per hour per recipient
  const rateLimitKey = `email_${recipientEmail}`;
  if (!checkRateLimit(rateLimitKey, 20, 3600000)) {
    return; // Silently fail to prevent spam
  }

  try {
    const email = templates[emailType](...templateData);
    
    const { data, error } = await supabase.functions.invoke('send-application-email', {
      body: {
        to: recipientEmail,
        subject: email.subject,
        html: email.html,
        text: email.text
      }
    });

    if (error) {
      // Email error - silent fail
    }
  } catch (error) {
    // Failed to send email - silent fail
  }
}

// 1. Send disqualification email
export async function sendDisqualificationEmail(candidateEmail, candidateName, jobTitle, companyName, reason = null) {
  await sendEmailTemplate('disqualification', candidateEmail, [candidateName, jobTitle, companyName, reason]);
}

// 2. Send next step email
export async function sendNextStepEmail(candidateEmail, candidateName, jobTitle, companyName, stage, jobLink, jobId = null) {
  await sendEmailTemplate('nextStep', candidateEmail, [candidateName, jobTitle, companyName, stage, jobLink, jobId]);
}

// 3. Send account deleted email
export async function sendAccountDeletedEmail(userEmail, userName) {
  await sendEmailTemplate('accountDeleted', userEmail, [userName]);
}

// 4. Send team invite email
export async function sendTeamInviteEmail(inviteeEmail, inviteeName, inviterName, companyName, role, inviteLink) {
  await sendEmailTemplate('teamInvite', inviteeEmail, [inviteeName, inviterName, companyName, role, inviteLink]);
}

// 5. Send complete profile reminder
export async function sendCompleteProfileEmail(userEmail, userName) {
  await sendEmailTemplate('completeProfile', userEmail, [userName]);
}

// 6. Send new job match notification
export async function sendJobMatchEmail(candidateEmail, candidateName, jobLink) {
  await sendEmailTemplate('jobMatch', candidateEmail, [candidateName, jobLink]);
}

// 7. Send new message notification
export async function sendNewMessageEmail(recipientEmail, recipientName, senderName, messageLink, messageCount = 1) {
  await sendEmailTemplate('newMessage', recipientEmail, [recipientName, senderName, messageLink, messageCount]);
}

// 8. Send candidate verification request (admin notification)
export async function sendCandidateVerificationRequestEmail(adminEmail, candidateName, reviewLink) {
  await sendEmailTemplate('candidateVerificationRequest', adminEmail, [candidateName, reviewLink]);
}

